import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { ReportTypeReducer } from './reducer';
import { EffectsModule } from '@ngrx/effects';
import { ReportTypeEffects } from './effects';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('reportType', ReportTypeReducer),
    EffectsModule.forFeature([ReportTypeEffects])
  ]
})
export class ReportTypeStoreModule { }
